
export default {
  name: 'TapToast',
  props: {
    content: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      show: true,
    };
  },
  methods: {
    close() {
      this.show = false;
      setTimeout(() => {
        this.$el.remove();
      }, 300);
    },
  },
};
